'use client'
import React, { ReactElement, useState } from 'react'
import { Extra } from '@/types/Misc'
import { useTranslations } from 'next-intl'
import { HotelSlider } from '@/components/hotel/HotelSlider'
import HotelExtra from '@/components/ui/hotel-extras/HotelExtra'
import { HotelExtraModal } from '@/components/ui/hotel-extras/HotelExtraModal'
import { BookingRequestExtraSelection } from '@/types/Booking'

export function HotelExtras(props: {
  extras: Extra[]
  maxQuantity?: number
  updateBooking?: (data: { Extras: BookingRequestExtraSelection[] }) => void
  bookingSelectionExtras?: BookingRequestExtraSelection[]
  headline: boolean
  showSubtext?: boolean
}): ReactElement | null {
  const t = useTranslations('Hotel.HotelExtras')
  const [selectedModalIndex, setSelectedModalIndex] = useState<number | undefined>()

  const sliderElements = props.extras.map((extra, index) => (
    <HotelExtra
      extra={extra}
      key={extra.bookingcode}
      {...props}
      showMoreDetailsClicked={() => setSelectedModalIndex(index)}
    />
  ))

  const modalElements = props.extras.map((extra) => (
    <HotelExtraModal extra={extra} key={extra.bookingcode} showSubtext={props.showSubtext} />
  ))

  return (
    <>
      {props.headline ? (
        <h4 className="mb-6 text-3xl font-bold text-stone-900 md:text-4xl">{t('headline')}</h4>
      ) : null}
      <HotelSlider
        sliderElements={sliderElements}
        modalElements={modalElements}
        usedWithoutMargin
        selectedModalIndex={selectedModalIndex}
        setSelectedModalIndex={setSelectedModalIndex}
      />
    </>
  )
}
